export default __webpack_public_path__ + "static/media/Street lights-mini.8b7a6b88.jpg";